import { defineVuePlugin } from '#/vue-plugins'

import { useActivityTracking } from '@/shared/lib'

import { useProfile } from '@/entities/profile'

export default defineVuePlugin((app) => {
  app.mixin({
    mounted() {
      // Only run once at the root level
      if (this.$root === this) {
        const { profile } = storeToRefs(useProfile())
        const { initActivityTracking, endSession } = useActivityTracking()

        let cleanup: (() => void) | null = null

        watch(
          profile,
          (newProfile) => {
            if (newProfile) {
              cleanup = initActivityTracking()

              if (typeof window !== 'undefined') {
                window.addEventListener('beforeunload', () => {
                  endSession('page_unload')
                })

                let blurTimeout: NodeJS.Timeout | null = null

                document.addEventListener('visibilitychange', () => {
                  if (document.visibilityState === 'hidden') {
                    blurTimeout = setTimeout(
                      () => {
                        endSession('long_inactivity')
                      },
                      10 * 60 * 1000,
                    )
                  } else if (document.visibilityState === 'visible' && blurTimeout) {
                    clearTimeout(blurTimeout)
                    blurTimeout = null
                  }
                })
              }
            }
          },
          { immediate: true },
        )

        // Cleanup on unmount
        onUnmounted(() => {
          if (cleanup) {
            cleanup()
          }
        })
      }
    },
  })
})
